module.exports = __webpack_public_path__ + "media/application/assets/images/logo_steig_um_ein-64b461b3d34676a6097c32b1a9263164.png";